import { useMemo } from 'react'

// Contexts
import { useWalletContext } from 'providers/WalletProvider'

export const useReady = (): boolean => {
  const { isUserConnected, isWalletLoading, isChainConnected } =
    useWalletContext()

  const isAllReady = useMemo(
    () => !isWalletLoading && isChainConnected && isUserConnected,
    [isWalletLoading, isChainConnected, isUserConnected]
  )

  return isAllReady
}

export const useBridge = (): boolean => {
    const { isUserConnected, isWalletLoading, isChainAccepted } =
        useWalletContext()

    const isAllAccepted = useMemo(
        () => !isWalletLoading && isChainAccepted && isUserConnected,
        [isWalletLoading, isChainAccepted, isUserConnected]
    )

    return isAllAccepted
}
